import { Styles } from 'shared/types';
import { grays } from 'shared/utils';

export const Counter: Styles = {
  background: grays.slateGray,
  fontWeight: '500',
  mb: 2,
};
